var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('br'),_c('br'),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.itens,"item-key":"id"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('b',[_c('span',[_vm._v("Comparativo de dados:")])])
}]

export { render, staticRenderFns }